import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/share';
import { UrlManagerService } from './url-manager.service';
import { LoginService } from './login.service'
import { Router } from '@angular/router';

@Injectable()
export class GetService {

  constructor(private http: Http, private UrlManager: UrlManagerService, private router: Router) {
  }

  getLocations() {
    var Obserable = this.http.get(this.UrlManager.getApiUrl() + "/location", this.UrlManager.getOptions()).map(res => res.json());
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }

  getCheckUser() {
    var Obserable = this.http.get(this.UrlManager.getAuthUrl() + "/authenticate/verify", this.UrlManager.getOptions()).map(res => res);
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }

  getCheckAdmin() {
    var Obserable = this.http.get(this.UrlManager.getAuthUrl() + "/authenticate/admin", this.UrlManager.getOptions()).map(res => res);
    Obserable.subscribe((res) => { }, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }

  getInstances() {
    var Obserable = this.http.get(this.UrlManager.getAuthUrl() + "/inst", this.UrlManager.getOptions()).map(res => res.json());
    Obserable.subscribe((res) => {}, (error) => {
      if (error.status != 200) {
        console.log(error);
        this.router.navigate(['home']);
      }
    });
    return Obserable;
  }


}



// WEBPACK FOOTER //
// ./src/app/Services/get.service.ts